<template>
      <div>
            <!-- Headline Slot -->
            <slot name="headline"></slot>

            <!-- Body -->
            <j-card v-if="!isLoading" class="bg5">
                  <!-- If Expendable is False, show list version -->
                  <j-list v-if="!isExpandable" :list="computedListing">
                        <div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
                              <div class="flex xs-6 xs-left xs-middle fw7 c6">{{ item.id }}</div>
                              <!-- If id is passed , name will be turned into link -->
                              <div v-if="item.id === $t('name')" class="flex xs-6 xs-left xs-middle">
                                    <router-link v-if="hasLink" :to="computedLink">
                                          {{
                                          item.value
                                          }}
                                    </router-link>
                                    <div v-else>{{ item.value }}</div>
                              </div>
                              <!-- Else -->
                              <div v-else class="flex xs-6 xs-left xs-middle">{{ item.value }}</div>
                        </div>
                  </j-list>

                  <!-- If Expendable is True, show expendable box version -->
                  <j-expendable-box v-if="isExpandable">
                        <!-- Return name of individual as header for expendable box -->
                        <div slot="header" class="p3 fs3 fw7 c2">{{ this.computedListing[0].value }}</div>
                        <div slot="body">
                              <j-list :list="computedListing">
                                    <div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
                                          <div class="flex xs-6 xs-left xs-middle fw7 c6">{{ item.id }}</div>
                                          <div class="flex xs-6 xs-left xs-middle">{{ item.value }}</div>
                                    </div>
                              </j-list>
                        </div>
                  </j-expendable-box>
            </j-card>

            <!-- Loading -->
            <j-spinner v-if="isLoading"/>

            <!-- Footer Slot -->
            <slot name="footer"></slot>
      </div>
</template>

<script>
import JCard from "@/components/JCard/"
import JList from "@/components/JList/"
import JExpendableBox from "@/components/JExpendableBox"
import JSpinner from "@/components/JSpinner"
import dayjs from "dayjs"

export default {
	components: {
		JCard,
		JList,
		JExpendableBox,
		JSpinner
	},

	props: {
		id: String,
		name: String,
		gender: String,
		salutation: String,
		englishFirstName: String,
		englishLastName: String,
		chineseFirstName: String,
		chineseLastName: String,
		dateOfBirth: String,
		maritalStatus: String,
		occupation: String,
		countryOfResidency: String,
		acceptsMarketing: Boolean,
		preferredCommunicationChannel: String,
		preferredLanguage: String,

		isExpandable: {
			type: Boolean,
			default: false
		},

		hasLink: {
			type: Boolean,
			default: false
		},

		isLoading: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		// Map props to computedListing Array
		computedListing() {
			return [
				{ id: this.$t("name"), value: this.name },
				{ id: this.$t("gender"), value: this.gender },
				{ id: this.$t("salutation"), value: this.salutation },
				{
					id: this.$t("english_first_name"),
					value: this.englishFirstName
				},
				{
					id: this.$t("english_last_name"),
					value: this.englishLastName
				},
				{
					id: this.$t("chinese_first_name"),
					value: this.chineseFirstName
				},
				{
					id: this.$t("chinese_last_name"),
					value: this.chineseLastName
				},
				{
					id: this.$t("date_of_birth"),
					value: this.dateOfBirth
						? dayjs(this.dateOfBirth).format(
								"DD/MM/YYYY"
						  )
						: null
				},
				{
					id: this.$t("marital_status"),
					value: this.maritalStatus
				},
				{ id: this.$t("occupation"), value: this.occupation },
				{
					id: this.$t("country_of_residency"),
					value: this.countryOfResidency
						? this.$t(
								`countries.${
									this.countryOfResidency
								}`
						  )
						: null
				},
				{
					id: this.$t("accepts_marketing"),
					value: this.acceptsMarketing
						? this.$t("yes")
						: !this.acceptsMarketing
						? this.$t("no")
						: this.$t("no")
				},
				{
					id: this.$t("preferred_communication_channel"),
					value: this.preferredCommunicationChannel
				},
				{
					id: this.$t("preferred_language"),
					value: this.preferredLanguage
				}
			]
		},

		// Link to client overview
		computedLink() {
			return `/${this.$store.state.tenantId}/clients/detail/${
				this.id
			}/overview/individual`
		}
	}
}
</script>
